module.exports = __webpack_public_path__ + "img/11.51dfb8e0.jpg";